export class DoricPlugin {
    constructor(context) {
        this.context = context;
    }
    onTearDown() {
    }
}
